import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import _ from "lodash";
import cx from "classnames";

import { Icon } from "semantic-ui-react";
import { updateUser, activateUser } from "actions/users";

import SaveChanges from "components/ui/Buttons/SaveButton";
import Cancel from "components/ui/Buttons/CancelButton";

import styles from "./basic.module.scss";
import {
  Checkbox,
  Container,
  Dropdown,
  Form,
  Grid,
  Input,
  Label,
} from "semantic-ui-react";
import ConfirmModal from "components/ui/ConfirmModal";
import { isAccountSuspended } from "components/features/Util/Util";

const initUser = {
  email: null,
  userName: null,
  role: null,
  firstName: null,
  lastName: null,
  mobilePhone: null,
  overrideSSOConfiguration: null,
  locked: false,
  cleverstory: false,
};

const initErrorFields = [
  {
    name: "firstName",
    error: false,
  },
  {
    name: "email",
    error: false,
  },
  {
    name: "userName",
    error: false,
  },
  {
    name: "role",
    error: false,
  },
];

const roleOptions = [
  { key: 0, text: "Administrator", value: "administrator" },
  { key: 1, text: "Content Publisher", value: "publisher" },
  { key: 2, text: "BI Analyst", value: "bi_analyst" },
  { key: 3, text: "Normal User", value: "normal_user" },
];

export default function Basic({ user, permissionData }) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [isReset, setReset] = useState(false);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  const [isButtonDisabled, setButtonDisabled] = useState(true);
  const [initialRendering, setInitialRender] = useState(true);

  const [error, setError] = useState(null);
  const [emailError, setEmailError] = useState(null);
  const [errorFields, setErrorFields] = useState(initErrorFields);

  const [userCopy, setUserCopy] = useState(initUser);
  const [userChange, setUserChange] = useState({});

  const account = useSelector((state) => state.accounts.account);
  const updatingUser = useSelector((state) =>
    _.get(state, "users.updatingUser")
  );

  useEffect(() => {
    console.log("users", user);

  }, [])

  useEffect(() => {
    console.log("users", user);

    if (user) {
      setUserCopy({
        ...user,
        mobilePhone: user.mobilePhone ? user.mobilePhone : "",
        role: user.roles ? _.get(user, 'roles[0].key') : null,
      });
    }
  }, [user]);

  useEffect(() => {
    console.log("users", user);

    if (user) {
      let change = {};
      for (const [key, value] of Object.entries(user)) {
        if (key === "roles" && user.roles) {
          if (_.get(user, 'roles[0].key') !== userCopy.role) {
            change.role = userCopy.role;
          }
        } else if (value != userCopy[key]) {
          change[key] = userCopy[key];
        }
      }
      setUserChange(change);
    }
  }, [userCopy]);

  useEffect(() => {
    validateFields();
  }, [userCopy]);


  useEffect(() => {
    if (userChange && Object.entries(userChange).length > 0) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [userChange]);

  useEffect(() => {
    if (!initialRendering && updatingUser && !updatingUser.updating) {
      if (updatingUser.success) {
        toast.success(`${user.firstName} updated successfully`);
      } else {
        toast.error(updatingUser.error);
      }
    }
  }, [updatingUser]);

  setTimeout(() => {
    setInitialRender(false);
  }, [3000]);

  const changeToLowerCase = (email) => {
    setUserCopy({ ...userCopy, email: email.toLowerCase() })
  }

  const validateEmail = (email) => {
    const mailFormat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(mailFormat)) {
      setEmailError(null);
      return true;
    }
    setEmailError("Invalid Email!");
    return false;
  };

  const isFieldError = (fieldName) => {
    let error = false;
    if (isFormSubmitted) {
      errorFields.forEach((field, idx) => {
        if (field.name === fieldName && field.error) {
          error = true;
        }
      });
    }

    return error;
  };

  const isFormValid = () => {
    let errors = errorFields.filter((item) => item.error);
    if (errors.length > 0) return false;

    return true;
  };

  const validateFields = () => {
    let fields = [];
    for (var i = 0; i < errorFields.length; i++) {
      let value = userCopy[errorFields[i].name];

      errorFields[i].error =
        value === null || value === undefined || value === "" ? true : false;
      fields.push(errorFields[i]);
    }
    setErrorFields(fields);
  };

  const handleUserNameChange = (e) => {
   const value = e.target.value;
    const regex = /^\S*$/; 
     if (regex.test(value)) {
    setUserCopy({ ...userCopy, userName: value });
  }
  };

  const onSaveChanges = (e) => {
    e.preventDefault();

    if (e.type === "submit" && !isReset) {
      setFormSubmitted(true);
      if (isFormValid() && validateEmail(userCopy.email)) {
        setOpen(true);
      } else {
        setError("Please enter values for required fields.");
      }
    }
  };

  const onSaveChangesConfirm = () => {
    console.log(userChange, "userChange");

    dispatch(updateUser({ id: user.id, user: userChange }));
    setOpen(false);
  };

  const onCancelChanges = (e) => {
    setOpen(false);
    setError(null);
    setFormSubmitted(false);
    setReset(true);

    if (user) {
      setUserCopy({
        ...user,
        mobilePhone: user.mobilePhone ? user.mobilePhone : "",
        role: user.roles ? user.roles[0].key : null,
      });
    }

    setTimeout(() => {
      setReset(false);
    }, [500]);
  };

  return (
    <>
      <Container className={cx(styles.basic)}>
        <div className={cx(styles.title)}>User Details</div>
        <Form onSubmit={onSaveChanges}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  className={styles.userFormInput}
                  fluid
                  id="firstName"
                  label={"First Name"}
                  placeholder="First Name"
                  value={userCopy.firstName}
                  onChange={(e) =>
                    setUserCopy({ ...userCopy, firstName: e.target.value })
                  }
                  error={isFieldError("firstName")}
                  disabled={isAccountSuspended(account)}
                ></Form.Input>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  className={styles.userFormInput}
                  fluid
                  id="lastName"
                  label={"Last Name"}
                  placeholder="Last Name"
                  value={userCopy.lastName}
                  onChange={(e) =>
                    setUserCopy({ ...userCopy, lastName: e.target.value })
                  }
                  disabled={isAccountSuspended(account)}
                ></Form.Input>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  className={styles.userFormInput}
                  fluid
                  id="email"
                  label={"Email"}
                  placeholder="Email"
                  value={userCopy.email}
                  onChange={(e) =>
                    setUserCopy({ ...userCopy, email: e.target.value })
                  }
                  onBlur={(e) => {
                    changeToLowerCase(e.target.value)
                  }}
                  error={isFieldError("email")}
                  disabled={isAccountSuspended(account)}
                ></Form.Input>
              </Grid.Column>
            </Grid.Row>
            
            <Grid.Row>
              <Grid.Column>
                <Form.Input
                   className={styles.userFormInput}
                    fluid
                     id="userName"
                     label={"User Name"}
                      placeholder="User Name"
                       value={userCopy.userName}
                       onChange={handleUserNameChange}
                      error={isFieldError("userName")}
                     disabled={isAccountSuspended(account)}
                   ></Form.Input>
                    </Grid.Column>
            </Grid.Row>


            <Grid.Row>
              <Grid.Column>
                <Form.Input
                  className={styles.userFormInput}
                  fluid
                  id="mobilePhone"
                  label={"Phone"}
                  placeholder="Phone"
                  value={userCopy.mobilePhone}
                  onChange={(e) => {
                    setUserCopy({ ...userCopy, mobilePhone: e.target.value });
                  }}
                  disabled={isAccountSuspended(account)}
                ></Form.Input>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <Form.Dropdown
                  className={styles.userFormInput}
                  id="role"
                  label="Role"
                  placeholder="Role"
                  value={userCopy.role}
                  onChange={(e, data) =>
                    setUserCopy({ ...userCopy, role: data.value })
                  }
                  selection
                  options={roleOptions}
                  error={isFieldError("role")}
                  disabled={isAccountSuspended(account)}
                ></Form.Dropdown>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={11}>
                <div className={styles.formLabel}>
                  {userCopy.locked ? "Unlock this user" : "Lock this user"}
                </div>
              </Grid.Column>
              <Grid.Column width={5} className={styles.ssoToggle}>
                <Icon
                  onClick={() =>
                    setUserCopy({
                      ...userCopy,
                      locked: !userCopy.locked,
                    })
                  }
                  className={cx({
                    [styles.lockUser]: userCopy.locked,
                    [styles.unlockUser]: !userCopy.locked,
                  })}

                  name={userCopy.locked ? "lock" : "unlock"}
                  disabled={(!_.get(permissionData, 'user.block'))}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={11}>
                <div className={styles.formLabel}>
                  Override SSO Configuration
                </div>
              </Grid.Column>
              <Grid.Column width={5} className={styles.ssoToggle}>
                <Checkbox
                  className={styles.settingsToggle}
                  toggle
                  checked={userCopy.overrideSSOConfiguration}
                  onChange={(e, { checked }) => {
                    setUserCopy({
                      ...userCopy,
                      overrideSSOConfiguration: checked,
                    });
                  }}
                  disabled={isAccountSuspended(account) || (!_.get(permissionData, 'user.write'))}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={11} className={styles.text}>
                <div className={cx(styles.formLabel)}>Cleverstory</div>
              </Grid.Column>
              <Grid.Column width={5} className={styles.ssoToggle}>
                <Checkbox
                  className={styles.settingsToggle}
                  toggle
                  checked={userCopy.cleverstory}
                  onChange={(e, { checked }) => {
                    setUserCopy({
                      ...userCopy,
                      cleverstory: checked,
                    });
                  }}
                  disabled={isAccountSuspended(account) || (!_.get(permissionData, 'user.write'))}
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row columns={2}>
              <Grid.Column width={6}>
                {!isFormValid() && (
                  <div className={cx(styles.error)}> {error}</div>
                )}
                {emailError && (
                  <div className={cx(styles.error)}> {emailError}</div>
                )}
              </Grid.Column>
              <Grid.Column textAlign="right" width={10}>
                <SaveChanges
                  type="submit"
                  disabled={isAccountSuspended(account) || isButtonDisabled || (!_.get(permissionData, 'user.write'))}
                />
                <Cancel
                  content="Reset"
                  onClick={onCancelChanges}
                  disabled={isAccountSuspended(account) || isButtonDisabled || (!_.get(permissionData, 'user.write'))}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>

        <ConfirmModal
          open={open}
          setOpen={setOpen}
          onSave={onSaveChangesConfirm}
          onCancel={onCancelChanges}
          content={`Are you sure want to update ${user ? user.name : ""}?`}
        />
      </Container>
    </>
  );
}
